import { Popover, Stack, useTheme, alpha } from "@mui/material";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

interface ColorPickerPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  // Cor atual em hex de 9 caracteres (#RRGGBBAA); aceita 7 (#RRGGBB) ou vazio.
  value: string;
  onChange: (next: string) => void;
  onClose: () => void;
}

// Popover de seleção de cor reaproveitável (mesmo comportamento do picker da
// creationSidebarEasymaps): HexAlphaColorPicker + HexColorInput, com tratamento
// de alpha em hex de 9 caracteres. Mantido autocontido para uso na tabela de
// edição em massa (tipos Texto e Área).
export function ColorPickerPopover({
  open,
  anchorEl,
  value,
  onChange,
  onClose,
}: ColorPickerPopoverProps) {
  const theme = useTheme();
  const current = value || "";

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            borderRadius: "12px",
            bgcolor: theme.palette.background.paper,
            backgroundImage: "none",
            overflow: "hidden",
          },
        },
      }}
    >
      <Stack sx={{ p: 1.5, width: 220 }} gap={1.5}>
        <HexAlphaColorPicker
          style={{ width: "100%" }}
          color={current.length === 7 ? current + "ff" : current || "#ffffffff"}
          onChange={(hex) => onChange(hex)}
        />
        <HexColorInput
          prefixed
          color={(current || "#ffffffff").slice(0, 7)}
          onChange={(hex) => {
            const alphaSeg =
              current && current.length === 9 ? current.slice(7) : "ff";
            onChange(hex + alphaSeg);
          }}
          style={{
            width: "100%",
            boxSizing: "border-box",
            background: alpha(theme.palette.text.primary, 0.06),
            color: theme.palette.text.primary,
            border: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
            borderRadius: 6,
            padding: "6px 8px",
            textTransform: "uppercase",
            outline: "none",
          }}
        />
      </Stack>
    </Popover>
  );
}

export default ColorPickerPopover;
